export default "__VITE_ASSET__495132d6__"